export class GcpRestoreGrantedServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gce",
            "baseName": "gce",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcs",
            "baseName": "gcs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudsql",
            "baseName": "cloudsql",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "bigquery",
            "baseName": "bigquery",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreGrantedServices.attributeTypeMap;
    }
    constructor() {
    }
}
